import gql from 'graphql-tag';
import { userDiscountFragment } from 'graphql/fragments';

const isDiscountUsedInCartQuery = gql`
  query isDiscountUsedInCart($_id: ID!) {
    discountById(_id: $_id) {
      ...userDiscountFragment
      usedInShoppingCart
    }
  }
  ${userDiscountFragment}
`;

export default isDiscountUsedInCartQuery;
